import { Card, Col, Row, Slider, Typography } from "antd";
import { useMemo, useState } from "react";
import LineChart from "../../components/charts/apexLineChart";

const { Text } = Typography;

export default function TimeSeriesChartWrapper({ data, isLoading }) {
  const [selectedAggregation, setSelectedAggregation] = useState(5);

  const timegraphData = useMemo(() => {
    if (!data) return null;

    return {
      x: data["historic_time"] || [],
      y: data["historic_amount_of_people"] || [],
      xLabel: "Data",
      yLabel: "Pessoas",
    };
  }, [data]);

  return (
    <Card
      title="Total de pessoas ao longo do tempo"
      align="center"
      style={{
        width: "85%",
      }}
      loading={isLoading}
      styles={{
        header: {
          backgroundColor: "#d0d6e2",
        },
      }}>
      <Row gutter={16}>
        <Col span={12} align="right">
          <Text strong style={{ marginRight: 10 }}>
            Escolha o período de agregação em minutos:
          </Text>
        </Col>
        <Col span={12} align="left">
          <Slider
            defaultValue={5}
            min={1}
            max={30}
            marks={{
              1: "1",
              15: "15",
              30: "30",
            }}
            style={{ width: "200px" }}
            onChangeComplete={(period) => setSelectedAggregation(period)}
          />
        </Col>
      </Row>
      <LineChart
        title="Média de pessoas na loja"
        data={timegraphData}
        intervalMinutes={selectedAggregation}
      />
    </Card>
  );
}
